import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static get values() {
    return {
      url: String,
    };
  }

  connect() {
    if (!this.urlValue) {
      return;
    }
    const carenRememberSetting = localStorage.getItem("caren.rememberUser");
    const carenSessionToken = localStorage.getItem("caren.sessionToken");

    if (carenRememberSetting == '"true"' && carenSessionToken.length > 0) {
      location.replace(this.urlValue);
    }
  }
}
